exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku-select[data-v-93c18b74]  .el-form-item.is-error .el-input__inner{border-color:#dddfe7 !important}.sku-select .selWidth[data-v-93c18b74]{width:300px}", ""]);

// exports
